/*
  "Hemen Satın Alın" butonu.

  Shopify'in dinamik ödeme butonunun metni değiştirilemediği için kendi
  butonumuzu kullanıyoruz: ürünü sepete ekler ve ödeme adımına gönderir.

  Buton, bulunduğu ürün formundaki varyant ve adet değerlerini okur; bu yüzden
  varyant değişiminde ayrıca güncelleme gerekmez.
*/
(() => {
  const YUKLENIYOR = 'is-loading';

  const sepeteEkleVeOde = async (btn) => {
    const form = btn.closest('form');
    if (!form) return;

    const variantInput = form.querySelector('input[name="id"]');
    const qtyInput = form.querySelector('input[name="quantity"]');
    const variantId = variantInput?.value || btn.dataset.variantId;
    if (!variantId) return;

    const quantity = parseInt(qtyInput?.value, 10) || 1;

    btn.classList.add(YUKLENIYOR);
    btn.disabled = true;

    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });

      if (!res.ok) throw new Error('Sepete eklenemedi');

      window.location.href = `${window.Shopify?.routes?.root || '/'}checkout`;
    } catch (e) {
      // Hata durumunda buton tekrar kullanilabilir kalsin; kullanici
      // normal "Sepete Ekle" ile devam edebilir.
      btn.classList.remove(YUKLENIYOR);
      btn.disabled = false;

      const hata = form.querySelector('.product_add_error');
      if (hata) {
        hata.textContent = 'Şu anda işleminiz tamamlanamadı. Lütfen tekrar deneyin.';
        hata.classList.remove('hidden');
      }
    }
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-mayis-buy-now]');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    sepeteEkleVeOde(btn);
  });
})();

/*
  Sepete Ekle durum etiketleri.

  Tema (scripts.js -> ProductForm) submit sirasinda butona .loading ekleyip
  .btn_text'i gizliyor, bittiginde geri aliyor. Basari mesajini tema
  gostermiyor; burada .loading kalktigi anda kisa sureli .is-added
  ekleniyor. Buton genisligi flex layout'tan geldigi icin metin degisimi
  layout kaymasi yaratmaz.

  Tema JS'ine dokunulmaz; yalnizca sinif degisimi izlenir.
*/
(() => {
  const BASARI_SURESI = 1800;

  const izle = (btn) => {
    if (btn.dataset.durumBagli) return;
    btn.dataset.durumBagli = '1';

    let yukleniyordu = btn.classList.contains('loading');
    let zamanlayici = null;

    /*
      ONEMLI: classList.add/remove, sinif zaten istenen haldeyken bile
      class niteligini yeniden yaziyor ve bu yeni bir mutation kaydi
      uretiyor. Gozlemcinin icinden kosulsuz cagrilirsa kendi kendini
      besleyip tarayiciyi kilitliyor. Bu yuzden yalnizca gercekten
      degisiklik gerekiyorsa DOM'a yaziyoruz.
    */
    const durumYaz = (ekle) => {
      if (btn.classList.contains('is-added') === ekle) return;
      btn.classList.toggle('is-added', ekle);
    };

    new MutationObserver(() => {
      const yukleniyor = btn.classList.contains('loading');

      if (yukleniyor) {
        clearTimeout(zamanlayici);
        durumYaz(false);
      } else if (yukleniyordu) {
        // Hata varsa basari gosterme
        const form = btn.closest('form');
        const hata = form && form.querySelector('.product_add_error');
        const hataVar = hata && !hata.classList.contains('hidden');

        if (!hataVar) {
          durumYaz(true);
          zamanlayici = setTimeout(() => durumYaz(false), BASARI_SURESI);
        }
      }

      yukleniyordu = yukleniyor;
    }).observe(btn, { attributes: true, attributeFilter: ['class'] });
  };

  const tara = () => document.querySelectorAll('.add_to_cart_btn').forEach(izle);

  tara();

  // main-product varyant degisiminde kendini yeniden basiyor; yeni butonu yakala
  const kok = document.querySelector('main-product');
  if (kok) {
    new MutationObserver(tara).observe(kok, { childList: true, subtree: true });
  }
})();
